import React from 'react';
import { Button } from '@chakra-ui/react';
import { FaHistory, FaPlusCircle } from 'react-icons/fa';

type Props = {
    onClickCreate?: () => void;
    onClickLog?: () => void;
};

function TrapezoidHeader(props: Props) {
    const { onClickCreate, onClickLog } = props;

    return (
        <div className="mt-2">
            <div className="trapezoid" style={{ width: 'auto', display: 'inline-block' }}>
                <span className="metadata-font">ADM-DMS104 Default Values Management</span>
            </div>
            <div style={{ display: 'inline', float: 'right' }}>
                <Button
                    colorScheme="purple"
                    size="sm"
                    leftIcon={<FaHistory />}
                    className="mx-1"
                    onClick={() => onClickLog?.()}
                >
                    Log
                </Button>
                <Button
                    colorScheme="green"
                    size="sm"
                    leftIcon={<FaPlusCircle />}
                    className="mx-1"
                    onClick={() => onClickCreate?.()}
                >
                    Create
                </Button>
            </div>
        </div>
    );
}

export default TrapezoidHeader;
